export const AUTH = {
  LOGIN: '/auth/login',
  REGISTER: '/auth/register'
};

export const HOME = '/home';
